<template>
  <div class="tournamentScreens">
    <div class="wrapper startList" :style="'zoom: ' + zoom + ' !important;'">
      <div class="head">
        <table>
          <tbody>
            <tr>
              <td style="white-space: nowrap">
                <h1>
                    {{ tournamentName }}<span class="logo" :style="{ backgroundImage: 'url(' + logoImg + ')' }"></span>
                </h1>
                <h2>{{ $t('startlist') }} {{ $t('round')}} {{selectedRound}} - {{ $t('sm' + tournamentScoringMode) }}</h2>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="tableHead">
        <table>
          <colgroup>
            <col style="width: 80px" />
            <col style="width: 80px" />
            <col style="width: 347px" />
            <col style="width: 347px" />
            <col style="width: 347px" />
            <col style="width: 347px" />
          </colgroup>
          <tbody>
            <tr>
              <th>TEE</th>
              <th>{{ $t('time') }}</th>
              <th class="left">{{ $t('flight') }}</th>
              <th colspan="3">
                <div class="ticker-container">
                   <marquee-text class="ticker-text" :key="currentTicker.id" :duration="8" :repeat="15">{{ currentTicker.tickerText }}&nbsp;&nbsp;&nbsp;</marquee-text></div>
                </th>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row" v-for="flight in startListPage" :key="flight">
        <div class="content">
          <table>
            <colgroup>
              <col style="width: 80px" />
              <col style="width: 80px" />
              <col style="width: 347px" />
              <col style="width: 347px" />
              <col style="width: 347px" />
              <col style="width: 347px" />
            </colgroup>
            <tbody>
              <tr>
                <td>{{ flight.startTee }}</td>
                <td>{{ flight.startTime }}</td>
                <td class="left" v-for="player in flight.players" :key="player">
                  <p style="line-height: 0.8; padding: 0; margin: 0; margin-left: 10px;">
                    <img style="vertical-align:middle" width="24" v-if="player.flag && player.flag != ''" :src="require('@/assets/images/flags_iso/' + player.flag + '.png')">{{ player.name }} <span style="font-size: 18px;">({{ player.hcp }})<br />{{ player.clubName }}</span>
                  </p>
                </td>
                <td v-for="i in 4-flight.players.length" :key="i"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      
      <div class="foot" :style="{ background: '#e4e7ea url(' + footerImg + ') center center / 550px no-repeat' }">
        <span>{{ associationName }}<br />{{ lastUpdate }} </span>
        <span v-if="isPaused==true" class="clicker fa fa-step-forward" @click="isPaused = !isPaused"></span>
        <span v-else class="clicker fa fa-pause" @click="isPaused = !isPaused"></span>
      </div>
    </div>
  </div>
</template>

<script>
import {  } from "@ionic/vue";
import { defineComponent, ref, watch, computed, getCurrentInstance } from "vue";
import { useQuery } from "@vue/apollo-composable";
import findTournamentStartListDMMQueryFile from "../graphql/findTournamentStartListDMM.query.gql";
import { useRoute, useRouter } from "vue-router";
import MarqueeText from 'vue-marquee-text-component'

export default defineComponent({
  name: "Startlist",
  components: {
    MarqueeText
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const app = getCurrentInstance()
    const changeLanguage = app.appContext.config.globalProperties.$changeLanguage

    var page = ref(0)
    var perPage = ref(10)
    var isPaused = ref(false)
    var switchURL = ref(route.query.switchURL)
    var switchTournaments = ref(route.query.switchTournaments)
    let startListPage = ref([])
    let nextPageIntervalId = ref(0)
    const selectedRound = ref(parseInt(route.params.rid)+1);

    const {result: findTournamentStartListDMMResult, refetch: findTournamentStartListDMMRefetch} = useQuery(findTournamentStartListDMMQueryFile, () => ({ 
        league_id: parseInt(route.params.lid),
        group_id: parseInt(route.params.gid),
        round_id: parseInt(route.params.rid),
        switchURL: switchURL?.value? parseInt(route.query.switchURL) : 0,
        switchTournaments: switchTournaments?.value?parseInt(route.query.switchTournaments):0
    }), () => ({ fetchPolicy: 'no-cache', enabled: route.params.lid != undefined && route.params.gid != undefined && route.params.rid != undefined } ))

    const currentTicker = computed(() => findTournamentStartListDMMResult.value?.findTournamentStartListDMM.currentTicker ?? '')
    const startList = computed(() => findTournamentStartListDMMResult.value?.findTournamentStartListDMM.tournamentStartList ?? [])
    const footerImg = computed(() => findTournamentStartListDMMResult.value?.findTournamentStartListDMM.footerImg ?? '')
    const logoImg = computed(() => findTournamentStartListDMMResult.value?.findTournamentStartListDMM.logoImg ?? '')
    const tournamentName = computed(() => findTournamentStartListDMMResult.value?.findTournamentStartListDMM.tournamentName ?? '')
    const tournamentPlayForm = computed(() => findTournamentStartListDMMResult.value?.findTournamentStartListDMM.tournamentPlayForm ?? '')
    const tournamentScoringMode = computed(() => findTournamentStartListDMMResult.value?.findTournamentStartListDMM.tournamentScoringMode ?? '')
    const showDuration = computed(() => findTournamentStartListDMMResult.value?.findTournamentStartListDMM.showDuration ?? 10)
    const maxPages = computed(() => findTournamentStartListDMMResult.value?.findTournamentStartListDMM.maxPages ?? 1000)
    const lang = computed(() => findTournamentStartListDMMResult.value?.findTournamentStartListDMM.lang ?? 'de')
    const livescoringNextLink = computed(() => findTournamentStartListDMMResult.value?.findTournamentStartListDMM.livescoringNextLink ?? '')
    const nextTournamentId = computed(() => findTournamentStartListDMMResult.value?.findTournamentStartListDMM.nextTournamentId ?? 0)
    const nextTournamentRoundIndex = computed(() => findTournamentStartListDMMResult.value?.findTournamentStartListDMM.nextTournamentRoundIndex ?? 0)
    const associationName = computed(() => findTournamentStartListDMMResult.value?.findTournamentStartListDMM.associationName ?? '')
    const lastUpdate = computed(() => findTournamentStartListDMMResult.value?.findTournamentStartListDMM.lastUpdate ?? '')
    const zoom = computed(() => findTournamentStartListDMMResult.value?.findTournamentStartListDMM.zoom ?? '100%')

    watch(lang, (newVal, oldVal) => {
      changeLanguage(newVal)
    })

    watch(livescoringNextLink, (newVal, oldVal) => {
      if(newVal && newVal != '' && switchURL?.value == 1 && window.location.href != newVal){
            window.location.href=newVal
        }
    }) 

    watch(startList, (newVal, oldVal) => {
      // init
      clearInterval(nextPageIntervalId.value)
      startListPage.value = startList.value.slice(0, perPage.value)
      nextPageIntervalId.value = setInterval(() => {
        if (!isPaused.value)
          page.value++;

        if (page.value * perPage.value >= startList.value.length || page.value >= maxPages.value) {
          if(switchTournaments?.value == 1 && nextTournamentId.value!=0 && nextTournamentRoundIndex.value!=0){
            window.location.href= window.location.href.replace(route.params.tid+'/'+route.params.roundIndex , nextTournamentId.value+'/'+nextTournamentRoundIndex.value)
          }else{
            page.value = 0
            findTournamentStartListDMMRefetch()
          }
        }
        else
          startListPage.value = startList.value.slice(page.value * perPage.value, page.value * perPage.value + perPage.value)

      }, showDuration.value * 1000)
    })

    return { 
      selectedRound, tournamentName,tournamentPlayForm,tournamentScoringMode, lastUpdate, associationName, logoImg, footerImg, isPaused, currentTicker, startListPage, zoom
    }
  },
});
</script>

<style scoped>

/* ############## tournament-screens.css ###########*/

.tournamentScreens {
  box-sizing: border-box;
  height: 100%;
  zoom: 80%;
}

.tournamentScreens {
  font: 14px/1.5 Helvetica, Helvetica, Tahoma, Verdana, sans-serif;
  color: #333;
  background: #000 right center /
    cover no-repeat fixed;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

.cf:after {
  content: "";
  display: table;
  clear: both;
}

.tournamentScreens div.wrapper {
  width: 1600px;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -800px;
  margin-top: -382px;
  height: 815px;
  box-shadow: 0 0 100px 0 rgba(255, 255, 255, 0.3);
  border-radius: 25px;
  overflow: hidden;
  zoom: 100%
}

.tournamentScreens div.tournamentList {
  height: 686px;
  overflow: auto;
  background: rgba(255, 255, 255, 0.85);
}

.tournamentScreens div.tournamentList table {
  border-collapse: separate;
  width: 100%;
}

.tournamentScreens div.tournamentList thead th {
  font-weight: normal;
  font-size: 25px;
  text-align: left;
}

.tournamentScreens div.tournamentList tbody td {
  border: solid 1px #fff;
}

.tournamentScreens div.tournamentList tbody td:first-of-type {
  border-left: none;
}

.tournamentScreens div.tournamentList tbody td:last-of-type {
  border-right: none;
}

.tournamentScreens div.tournamentList a {
  white-space: nowrap;
  color: #009ee0;
}

.tournamentScreens div.tournamentList table td,
.tournamentScreens div.tournamentList table th {
  padding: 5px;
}

.tournamentScreens div.row {
  height: 64px;
  padding: 1px; /* Dung: added */
}

.tournamentScreens div.row.club {
  height: 40px;
}

.tournamentScreens div.row.team {
  height: 84px;
}

.tournamentScreens div.head {
  height: 100px;
  padding: 15px 25px;
  background: rgba(0, 0, 0, 0.5);
  position: relative;
}

.tournamentScreens div.head span.logo {
  display: block;
  height: 50px;
  width: 200px;
  position: absolute;
  top: 25px;
  right: 25px;
  background: transparent no-repeat top left;
  background-size: contain;
}

.tournamentScreens div.head h1,
.tournamentScreens div.head h2 {
  margin: 0;
  font-weight: normal;
}

.tournamentScreens div.head h1 {
  color: #ffe600;
}

.tournamentScreens div.head h2 {
  color: #fff;
}

.tournamentScreens div.tableHead,
.tournamentScreens div.tournamentList table thead tr {
  height: 50px;
  background: #ffe600;
  color: #009ee0;
  padding: 0 25px;
}

.tournamentScreens div.content {
  color: #fff;
  background: rgba(0, 158, 224, 0.9);
  width: 1680px;
  margin-left: 0px;
  height: 64px;
  padding: 0 35px;
  font-size: 30px;
  box-shadow: inset 0 5px 10px 0 rgba(255, 255, 255, 0.4);
  border-bottom: solid 4px #000;
}

.tournamentScreens div.content.club {
  height: 40px;
}

.tournamentScreens div.content.team {
  height: 84px;
}

.tournamentScreens div.content.club {
  background: #009ee0;
  box-shadow: none;
}

.tournamentScreens div.content.club table {
  height: 40px;
  border: none;
}

.tournamentScreens div.content.club td {
  color: #ffe600;
  vertical-align: top;
  border: none;
  padding: 0 5px;
}

.tournamentScreens div.content.winner td {
  font-weight: bold;
  color: #ffe600;
}

.tournamentScreens div.content td.players {
  padding-left: 80px;
}

.tournamentScreens div.content img {
  display: inline-block;
  margin-top: -5px;
  vertical-align: middle;
}

.tournamentScreens div.tableHead table,
.tournamentScreens div.row table {
  height: 100%;
  table-layout: fixed;
  border-collapse: separate;
  width: 100%;
}

.tournamentScreens div.content table {
  width: 1550px;
  margin: 0 auto;
  border-left: solid 2px #000;
  border-right: solid 2px #000;
}

.tournamentScreens div.row td,
.tournamentScreens div.tableHead th {
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  font-size: 24px;
  white-space: nowrap;
  font-weight: normal;
  padding: 0px;
}

.tournamentScreens div.row td {
  border-left: solid 2px #000;
  border-right: solid 2px #000;
}

.tournamentScreens div.row .totalScore {
  font-weight: bold;
  color: #ffe600;
}

.tournamentScreens div.row td span.score {
  padding-left: 5px;
  font-weight: bold;
}

.tournamentScreens div.row td span.score,
.tournamentScreens div.row td span.strokes {
  display: inline-block;
  width: 45%; /* Dung: changed old: 50% */
  text-align: center;
}

.tournamentScreens div.row td span.scorenotfinishedleft {
  display: inline-block;
  width: 50%;
  text-align: center;
  font-weight: bold;
  color: #169a19;
  padding-right: 5px;
  border-right: solid 2px #169a19;
}

.tournamentScreens div.row td span.scorenotfinishedright {
  display: inline-block;
  width: 50%;
  text-align: center;
  padding-left: 5px;
  font-weight: bold;
  color: #169a19;
  padding-right: 5px;
  border-left: solid 2px #169a19;
}

.tournamentScreens div.row td.winner {
  color: #ffe600;
  font-weight: bold;
}

.tournamentScreens div.row td span.strokes {
  border-right: solid 2px rgba(0, 0, 0, 0.5);
  padding-right: 5px;
  font-weight: bold;
}

.tournamentScreens div.row td span.strokes.hole {
  font-weight: normal;
}

.tournamentScreens div.row td.left,
.tournamentScreens div.tableHead th.left {
  text-align: left;
}

.tournamentScreens div.row td.right,
.tournamentScreens div.tableHead th.right {
  text-align: right;
}

.tournamentScreens div.foot {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin-top: -4px;
  height: 29px;
  color: #fff;
  padding: 0 25px;
  line-height: 29px;
  background: rgba(0, 0, 0, 0.5);
}

.tournamentScreens div.foot_liga {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin-top: -4px;
  height: 29px;
  color: #fff;
  padding: 0 25px;
  line-height: 29px;
  background: rgba(0, 0, 0, 0.5);
}

.tournamentScreens div.foot_faldo {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin-top: -4px;
  height: 29px;
  color: #fff;
  padding: 0 25px;
  line-height: 29px;
  background: rgba(0, 0, 0, 0.5);
}

.tournamentScreens div.foot_berlin {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin-top: -4px;
  height: 29px;
  color: #fff;
  padding: 0 25px;
  line-height: 29px;
  background: rgba(0, 0, 0, 0.5);
}

.tournamentScreens div.yearSelect {
  padding: 5px;
}

.tournamentScreens div.tournamentList div.error {
  padding: 30px;
}

.linkBuilder {
  font-size: 12px;
}

.linkBuilder div.wrapper {
  padding: 50px;
  width: 920px;
  margin: 0 auto;
}

.linkBuilder div.tournamentSelect input {
  width: 100%;
}

.linkBuilder div.linkBox {
  background: #e8e8e8;
  padding: 20px;
  margin-bottom: 2em;
}

.linkBuilder div.left,
.linkBuilder div.right {
  width: 47.5%;
}

.linkBuilder div.left {
  margin-right: 55%;
}

.linkBuilder div.right {
  float: right;
}

.linkBuilder div.holder {
  padding-bottom: 5px;
  border-bottom: solid 2px #e8e8e8;
  margin-bottom: 5px;
}

.linkBuilder div.holder span.round {
  display: inline-block;
  overflow: hidden;
}

.linkBuilder div.left div.holder span.round {
  width: 360px;
}

.linkBuilder div.right div.holder span.round {
  width: 320px;
}

.linkBuilder i.control {
  font-size: 16px;
  display: inline-block;
  margin-right: 5px;
  float: right;
  cursor: pointer;
  color: #7f7f7f;
}

.linkBuilder div.right p {
  margin-top: 0;
  text-align: right;
}

.eagle {
  background: #f49183 !important;
}

.birdie {
  background: #eacebd !important;
}

.par {
  background: #b8e0c2 !important;
}

.bogey {
  background: #c2d3ec !important;
}

.doublebogey {
  background: #a1acbc !important;
}

.triplebogey {
  background: #60608c !important;
}

.albatros {
  background: #ede9c8 !important;
}

.borderBottom {
  border-bottom: solid 2px #000;
  border-color: black;
}

/* ############## ticker.css ###########*/
.ticker-container {
  border: 0px solid;
  overflow: hidden;
  margin-left: 0px;
  margin-right: 0px;
  color: red;
}

.ticker-text {
  height: 150%;
  font-size: 24px;
  white-space: nowrap;
  margin-top: 10px; /* Dung: added */
}

/* ############## overrides.css ###########*/

.teetimeMobile dark {
  background: transparent !important;
  color: #000 !important;
}

.tournamentScreens {
  font: 17px/1.5 Helvetica, Helvetica, Tahoma, Verdana, sans-serif;
  color: #000;
  background: #fff;
}

.tournamentScreens div.wrapper {
  background: transparent;
  border: solid 2px #e4e7ea;
  height: 853px;
  margin-top: -427px;
}

.tournamentScreens div.tournamentList {
  background: #fff;
}

.tournamentScreens div.tournamentList tbody td {
  border: solid 1px #e4e7ea;
}

.tournamentScreens div.tournamentList tbody td:first-of-type {
  border-left: solid 2px #e4e7ea;
}

.tournamentScreens div.tournamentList tbody td:last-of-type {
  border-right: solid 2px #e4e7ea;
}

.tournamentScreens div.tournamentList a {
  color: #000;
  text-decoration: none;
}

.tournamentScreens div.tournamentList a:hover {
  color: #6e7a8b;
}

.tournamentScreens div.tournamentList a:active {
  color: #1f355e;
}

.tournamentScreens div.head {
  background: #e4e7ea;
}

.tournamentScreens div.head h1 {
  color: #1f355e;
}

.tournamentScreens div.head h2 {
  font-size: 25px;
  font-weight: 400;
  color: #000;
}

.tournamentScreens div.head span.logo {
  background-position: top right;
}

.tournamentScreens div.tableHead,
.tournamentScreens div.tournamentList table thead tr {
  background: #bcc4cb;
  color: #1f355e;
}

.tournamentScreens div.content {
  color: #000;
  background: transparent;
  box-shadow: none;
  border-bottom: solid 2px #e4e7ea;
}

.tournamentScreens div.content img {
  display: inline-block;
  margin-top: -5px;
  vertical-align: middle;
}

.tournamentScreens div.content table {
  border-left: none;
  border-right: none;
}

.tournamentScreens div.row td {
  border-left: solid 1px #e4e7ea;
  border-right: solid 1px #e4e7ea;
}

.tournamentScreens div.row td:first-of-type {
  border-left: solid 2px #e4e7ea;
}

.tournamentScreens div.row td:last-of-type {
  border-right: solid 2px #e4e7ea;
}

.tournamentScreens div.foot {
  background: #e4e7ea
    center center / 640px no-repeat;
  color: #000;
  height: 60px;
}

.tournamentScreens div.foot_liga {
  color: #000;
  height: 60px;
}

.tournamentScreens div.yearSelect {
  border: solid 2px #e4e7ea;
}

.tournamentScreens div.head {
  position: static;
}

.tournamentScreens div.content.winner td {
  color: #79869e;
}

.tournamentScreens span.clicker {
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 150px;
}

.tournamentScreens div.row td.winner {
  color: #009ee0;
  font-weight: bold;
}

.tournamentScreens div.row .totalScore {
  font-weight: bold;
  color: #009ee0;
}

/* ############## normalize.css ###########*/
/*! normalize.css v3.0.2 | MIT License | git.io/normalize */
html {
  font-family: sans-serif;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}
body {
  margin: 0;
}
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section,
summary {
  display: block;
}
audio,
canvas,
progress,
video {
  display: inline-block;
  vertical-align: baseline;
}
audio:not([controls]) {
  display: none;
  height: 0;
}
[hidden],
template {
  display: none;
}
a {
  background-color: transparent;
}
a:active,
a:hover {
  outline: 0;
}
abbr[title] {
  border-bottom: 1px dotted;
}
b,
strong {
  font-weight: 700;
}
dfn {
  font-style: italic;
}
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}
mark {
  background: #ff0;
  color: #000;
}
small {
  font-size: 80%;
}
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sup {
  top: -0.5em;
}
sub {
  bottom: -0.25em;
}
img {
  border: 0;
}
svg:not(:root) {
  overflow: hidden;
}
figure {
  margin: 1em 40px;
}
hr {
  -moz-box-sizing: content-box;
  box-sizing: content-box;
  height: 0;
}
pre {
  overflow: auto;
}
code,
kbd,
pre,
samp {
  font-family: monospace, monospace;
  font-size: 1em;
}
button,
input,
optgroup,
select,
textarea {
  color: inherit;
  font: inherit;
  margin: 0;
}
button {
  overflow: visible;
}
button,
select {
  text-transform: none;
}
button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer;
}
button[disabled],
html input[disabled] {
  cursor: default;
}
button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}
input {
  line-height: normal;
}
input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
  padding: 0;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  height: auto;
}
input[type="search"] {
  -webkit-appearance: textfield;
  -moz-box-sizing: content-box;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}
fieldset {
  border: 1px solid silver;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}
legend {
  border: 0;
  padding: 0;
}
textarea {
  overflow: auto;
}
optgroup {
  font-weight: 700;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
td,
th {
  padding: 0;
}

</style>
